export default "__VITE_ASSET__Chak0MAf__"